const CONTENT_API_BASE =
  process.env.REACT_APP_CONTENT_API || "http://127.0.0.1:3030";

export const getContentApiBase = () => CONTENT_API_BASE;

export async function checkContentApi() {
  try {
    const res = await fetch(`${CONTENT_API_BASE}/api/health`, {
      method: "GET",
    });
    if (!res.ok) return false;
    const data = await res.json();
    return Boolean(data?.ok);
  } catch {
    return false;
  }
}

export async function applyDraftViaApi(draft) {
  const res = await fetch(`${CONTENT_API_BASE}/api/content/apply`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ draft }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(data.error || `Apply failed (${res.status})`);
  }
  return data;
}

export async function uploadFileViaApi(file) {
  const buffer = await file.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  const data = btoa(binary);
  const filename = file.name.replace(/\s+/g, "-");

  const res = await fetch(`${CONTENT_API_BASE}/api/files`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ filename, data }),
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok || !payload.ok) {
    throw new Error(payload.error || `Upload failed (${res.status})`);
  }
  return payload;
}
